<template>
    <div>
        <div class="form-group">
            <label>Access Token</label>
            <input type="text" class="form-control" v-model="data.access_token">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {};
    }
}
</script>
